import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { appendStoredQueryParams } from "../Utils/utm";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={appendStoredQueryParams("/apply-now")} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
